import { render, staticRenderFns } from "./BaseModalConfirm.vue?vue&type=template&id=2f5686a5&scoped=true&"
import script from "./BaseModalConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalConfirm.vue?vue&type=style&index=0&id=2f5686a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5686a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5686a5')) {
      api.createRecord('2f5686a5', component.options)
    } else {
      api.reload('2f5686a5', component.options)
    }
    module.hot.accept("./BaseModalConfirm.vue?vue&type=template&id=2f5686a5&scoped=true&", function () {
      api.rerender('2f5686a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Modals/BaseModalConfirm.vue"
export default component.exports